import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Discards the edited methodology once the record edits are discarded, so that
 * reopening the edit dialog starts from the value loaded from the backend.
 */
export const discardOnEditingDiscarded = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.editingPlugin.feature.actions.discard.success
      .observe()
      .pipe(rxjs.map(action => feature.actions.discard.from(action).create())),
)
